import React from "react";
import { Card, CardContent, Typography, Box, useTheme } from "@mui/material";

const StorePerformanceCard = ({
  performanceData,
}: {
  performanceData: Record<string, string | number>;
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: isDark ? theme.palette.background.paper : "#fff",
        height: "100%", // equal height
      }}
    >
      <CardContent>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Store Performance
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Key metrics and insights
        </Typography>

        <Box>
          {Object.entries(performanceData).map(([key, value], idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 1,
              }}
            >
              <Typography variant="body2">{key}</Typography>
              <Typography variant="body2" fontWeight="bold">
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StorePerformanceCard;
